// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__16EYx","productName":"Table_productName__nzBT7"};